import React from 'react';
import omit from 'lodash/omit';
import {
  TextField,
} from 'material-ui';

export default function TextRecord(props) {
  const {
    value, label, style,
  } = props;
  const baseStyle = {
    paddingTop: '2em',
    height: 'auto',
    display: 'block',
  };
  return (
    <TextField
      floatingLabelText={label}
      floatingLabelFixed
      underlineShow={false}
      style={{ ...baseStyle, ...style }}
      {...omit(props, ['value', 'style'])}
    >
      <span>{value}</span>
    </TextField>
  );
}
